import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { debounceTime, distinctUntilChanged, switchMap, catchError, of, finalize, take } from 'rxjs';
import { AlertComponent } from 'src/app/modules/components/alert/alert.component';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { ModalComponent } from 'src/app/modules/components/modal/modal.component';
import { FormatUtilsService } from 'src/app/modules/services/format-utils/format-utils.service';
import { RelatoriosContratuaisService } from 'src/app/modules/services/relatorios-contratuais/relatorios-contratuais.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { ModalVincularRelatorioComponent } from '../modal-vincular-relatorio/modal-vincular-relatorio.component';
import { AfericaoServicoInicialService } from '../../afericao-servico-Inicial/afericao-servico-inicial.service';
import { Router } from '@angular/router';
import { AfericaoRelatorioService } from 'src/app/modules/services/afericao-relatorio/afericao-relatorio.service';

@Component({
  selector: 'app-modal-view-relatorioo-vinculados',
  templateUrl: './modal-view-relatorioo-vinculados.component.html',
  styleUrls: ['./modal-view-relatorioo-vinculados.component.scss']
})
export class ModalViewRelatoriooVinculadosComponent {
afericaoId: any;
analiseAfericaoId: any;
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc'
  };
  columnConfig = [
    { columnDef: 'contrato', header: 'Contrato', property: 'relatorioContratual.contrato.contractNumber', customTd: true },
    { columnDef: 'relatorio', header: 'Nome do relatório', property: 'relatorioContratual.relatorio.nome' },
    { columnDef: 'prazo', header: 'Prazo', property: 'relatorioContratual.prazo', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];

  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [];
  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  totalElements = 0;

  // ========== Form Controls: Contratos ==========
  searchControl = new FormControl();
  filteredOptions: any[] = [];
  selectedOption: any;

  screenWidth: number = window.innerWidth;
  constructor(
    public toastService: ToastService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private loadingService: LoadingService,
    private formatUtilsService: FormatUtilsService,
    private dialogRef: MatDialogRef<ModalVincularRelatorioComponent>,
    private relatoriosContratuaisService: RelatoriosContratuaisService,
    private afericaoServicoInicialService: AfericaoServicoInicialService,
    private afericaoRelatorioService: AfericaoRelatorioService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { 
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    
    if(this.data.afericaoId){
      this.afericaoId = this.data.afericaoId;
    }
    if(this.data.analiseAfericaoId){
      this.analiseAfericaoId = this.data.analiseAfericaoId;
    }
    if(this.data.afericaoId && this.data.analiseAfericaoId){
      this.getData(0, this.afericaoId, this.analiseAfericaoId);
    }
  }

  getData(pageIndex: number = 0, afericaoId:string, analiseAfericaoId:string){
        this.afericaoServicoInicialService
          .getRelatoriosVinculados(
            this.pageSize,
            pageIndex,
            this.sortState.sortDirection,
            this.sortState.sortProperty,
            afericaoId,
            analiseAfericaoId
          )
          .pipe(
            take(1),
            finalize(() => this.loadingService.hideLoading())
          )
          .subscribe({
            next: (res: any) => {
              const {
                content,
                pageSize,
                totalPages,
                totalElements,
                pageNumber
              } = res;
              this.dataSource.data = content;
              this.pageSize = pageSize;
              this.totalPages = totalPages;
              this.totalElements = totalElements;
              this.pageIndex = pageNumber;
            },
            error: (erro: any) => this.handleRequestError(erro)
          });
      
  }
  private handleRequestError(erro: any): void {
    if (erro.status !== 500 && erro.status) {
      this.openSnackBar(erro.error.message, 'error');
    } else if (erro.error?.error === 'Unprocessable Entity') {
      this.openSnackBar(erro.error.message, 'warning');
    } else {
      this.openSnackBar(
        'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
        'error'
      );
    }
  }
    // === SNACKBAR DE ALERTA ===
  openSnackBar(description: string, type: string): void {
    const classMap: Record<string, string> = {
      sucess: 'snacbar-sucess',
      warning: 'snacbar-warning',
      error: 'snacbar-error'
    };

    const classSnack = classMap[type] || 'snacbar-default';

    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description, type },
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
  goToDetailAfericaoRelatorio(event:any){
      this.router.navigate([`detail-afericao-relatorios/${event}`]);
      this.cancel();
  }
 cancel(): void {
    this.dialogRef.close();
  }
}


